/* kx-live-angebot.js — Live-Gutschein (Präfix kx-la-, CLAUDE.md §17 „Live-Gutschein“).
 *
 * Gerendert von snippets/kx-live-angebot.liquid (jede Seite, layout/theme.liquid). Die Inhaberin schickt in der KARINEX-App
 * einem Besucher, der gerade im Shop ist, einen persönlichen Rabattcode; dieses Skript holt ihn ab und zeigt ihn als Fenster
 * auf der Seite, die der Besucher gerade ansieht.
 *
 * Einwilligung: gefragt wird NUR, wenn kxConsent.service('marketing.exit_voucher') === true (Schalter „Persönliche Gutscheine“)
 * UND karinex_cookie_settings.marketing.voucher_live === true (Kennzeichen des Wortlauts mit Live-Gutschein, gesetzt von
 * stampVoucherLive in assets/karinex-cookie-banner.js). Eine Auswahl von vor dem neuen Wortlaut fragt nie. Widerruf (kx:consent
 * aus dem Banner, Änderung in einem anderen Tab) beendet Abfrage und Fenster sofort und löscht den Sitzungs-Merker.
 *
 * Abfrage (Vertrag mit der App, /api/public/angebot): POST {shop: location.hostname, c: _id der Cookie-Auswahl oder ''} als Text
 * (einfache Anfrage ohne Preflight, ohne Cookies). Alle 20 s, solange der Tab sichtbar ist; im Hintergrund nie; beim Zurückkehren
 * in den Tab sofort (in einer Fehlerpause erst nach deren Ende).
 *   200 {ok, jetzt, angebot:null}       → in 20 s wieder
 *   200 {ok, jetzt, angebot:{code, prozent, bis}} → Fenster. Gleich danach bestätigt das Skript den Empfang: dieselbe Abfrage mit
 *       `ok: CODE` (keepalive, auch beim Seitenwechsel). Bis dahin liefert die App denselben Code bei jeder Abfrage dieser Nummer
 *       erneut (die erste Antwort kann verloren gehen, etwa wenn der Besucher gerade die Seite wechselt); kommt er trotzdem
 *       noch einmal, zeigt diese Seite ihn nicht wieder (`bekannt`) und bestätigt nur erneut. So kehrt das Fenster nach
 *       „Nein, danke“ nicht zurück.
 *   204 / 400 / 403 / 413 / andere 4xx → auf dieser Seite nicht mehr fragen
 *   429 / 5xx / Netz / Zeitüberschreitung / kaputte Antwort → wachsende Pause 40, 80, 160 s, höchstens 5 Minuten; nie ein Fenster
 *
 * Fenster: erst wenn nichts anderes offen ist (Cookie-Hinweis und -Einstellungen, Chat, Dialoge wie der Warenkorb, Menüs,
 * Sperrhinweis, Exit-Gutschein, Windows-Angebot, Einladung, Eingabe in einem Feld, Tab im Hintergrund). Solange es offen ist,
 * trägt <html> die Klasse kx-la-open; das Exit-Popup (snippets/kx-exit-intent.liquid) und das Windows-Angebot erscheinen dann nicht.
 * Countdown nur aus `bis`, gegen die Serverzeit `jetzt` gerechnet (eine falsche Geräteuhr ändert nichts); bei 0 schließt es, der
 * Code ist dann wirklich tot (§7, §9.33, §9.35). Nie ein Neustart.
 *
 * Speicher: nur sessionStorage 'kx_angebot' = {code, p, bis, v} (v = Abstand Serveruhr zu Geräteuhr), damit das Fenster nach
 * einem Seitenwechsel wieder erscheint. Gelöscht beim Schließen, Einlösen, Kopieren des Codes, Ablauf und Widerruf, und auf
 * jeder Seite (auch Rechtsseiten), die ohne Einwilligung geladen wird.
 *
 * „Jetzt einlösen“ ist ein <button> mit JS-Navigation nach /discount/CODE?redirect=<Pfad> (nie ein crawlbarer Link, §9.10).
 * ES5, keine Abhängigkeiten.
 */
(function () {
  'use strict';
  if (window.__kxLiveAngebot) return;
  window.__kxLiveAngebot = true;

  var me = document.currentScript;
  var tpl = document.getElementById('kxLaTpl');
  if (!me || !tpl || !('content' in tpl) || !window.fetch || !window.JSON) return;
  var API = me.getAttribute('data-api') || '';
  if (!/^https:\/\/[^\s]+$/.test(API)) return;
  var CSS = me.getAttribute('data-css') || '';
  var ROOT = me.getAttribute('data-root') || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var LANG = me.getAttribute('data-lang') || document.documentElement.lang || 'de';

  var POLL = 20000;        // Takt bei sichtbarem Tab
  var MAX = 300000;        // längste Pause nach Fehlern
  var START = 1500;        // erste Frage nach dem Laden bzw. nach der Zustimmung
  var WARTE = 1000;        // Fenster: erneut prüfen, ob es jetzt erscheinen darf
  var NACH_COOKIE = 2500;  // nach dem Cookie-Hinweis kurz Ruhe
  var ZEIT = 15000;        // Abbruch einer Abfrage (länger als die App für die Anlage des Codes bei Shopify höchstens braucht)
  var MERKER = 'kx_angebot';
  // Rechtstexte und das Widerrufsformular bleiben frei von Werbung: dort wird gar nicht gefragt und kein Fenster gezeigt
  // (auch mit Sprachpräfix /en/ …): Shopify-Richtlinien /policies/* und die eigenen Rechtsseiten unter /pages/.
  var OHNE = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:policies\/|pages\/(?:vertrag-widerrufen|widerrufsrecht|widerrufsbelehrung|widerruf|agb|datenschutz|datenschutzerklaerung|impressum|retouren-umtausch|rechtliche-hinweise)(?:\/|$))/i;
  var CODE_RE = /^[A-Za-z0-9][A-Za-z0-9_-]{2,31}$/;
  var NR_RE = /^[0-9a-f]{32}$/;
  var html = document.documentElement;

  // aus | fragt | wartet | offen | ende
  var zustand = 'aus';
  var generation = 0;
  var timer = null;
  var warteTimer = null;
  var tickTimer = null;
  var laeuft = false;
  var fehler = 0;
  var faellig = 0;
  var ctrl = null;
  var angebot = null;
  var root = null;
  var panel = null;
  var vorherFokus = null;
  var warteteCookie = false;
  var bekannt = {};        // Codes, die diese Seite schon bekommen hat (nie ein zweites Fenster mit demselben Code)

  // ── Einwilligung (nur Lesen; geschrieben wird karinex_cookie_settings ausschließlich vom Cookie-Hinweis) ──
  function auswahl() {
    try {
      var s = JSON.parse(localStorage.getItem('karinex_cookie_settings') || 'null');
      return s && typeof s === 'object' ? s : null;
    } catch (e) { return null; }
  }
  function erlaubt() {
    var s = auswahl();
    var m = s && s.marketing;
    if (!(m && typeof m === 'object' && m.voucher_live === true)) return false;
    var k = window.kxConsent;
    if (k && typeof k.service === 'function') {
      try { return k.service('marketing.exit_voucher') === true; } catch (e) { return false; }
    }
    return m.exit_voucher === true;
  }
  function nummer() {
    var s = auswahl();
    return s && typeof s._id === 'string' && NR_RE.test(s._id) ? s._id : '';
  }

  function sichtbar() { return document.visibilityState !== 'hidden'; }
  function zwei(n) { return (n < 10 ? '0' : '') + n; }

  // ── Sitzungs-Merker ──
  // Ohne Einwilligung liegt er nie im Browser: jede Stelle, die einen Widerruf bemerkt, löscht ihn (auch auf OHNE-Seiten).
  function merken(a) {
    try { sessionStorage.setItem(MERKER, JSON.stringify({ code: a.code, p: a.p, bis: a.bis, v: a.versatz })); } catch (e) {}
  }
  function vergessen() {
    try { sessionStorage.removeItem(MERKER); } catch (e) {}
  }
  function gemerkt() {
    var x = null;
    try { x = JSON.parse(sessionStorage.getItem(MERKER) || 'null'); } catch (e) { x = null; }
    if (!x || typeof x !== 'object') { vergessen(); return null; }
    var a = {
      code: typeof x.code === 'string' ? x.code : '',
      p: Number(x.p),
      bis: Number(x.bis),
      versatz: Number(x.v)
    };
    if (!CODE_RE.test(a.code) || !(a.p >= 1 && a.p <= 100) || !(a.bis > 0) || !isFinite(a.versatz) || rest(a) <= 5000) {
      vergessen();
      return null;
    }
    return a;
  }

  // Auf Rechtsseiten: nichts fragen, nichts zeigen. Nur aufräumen: ohne Einwilligung den Merker löschen, sofort und bei einem
  // Widerruf hier (Cookie-Einstellungen im Footer) oder in einem anderen Tab.
  if (OHNE.test(location.pathname || '/')) {
    var aufraeumen = function () { if (!erlaubt()) vergessen(); };
    aufraeumen();
    try {
      window.addEventListener('kx:consent', function () { setTimeout(aufraeumen, 0); });
      window.addEventListener('storage', function (e) {
        if (!e || e.key === null || e.key === 'karinex_cookie_settings' || e.key === 'karinex_cookie_consent') aufraeumen();
      });
    } catch (e) {}
    return;
  }

  // ── Abfrage ──
  function planen(ms) {
    if (timer) { clearTimeout(timer); timer = null; }
    if (zustand !== 'fragt') return;
    var d = typeof ms === 'number' ? ms : Math.min(MAX, POLL * Math.pow(2, Math.min(fehler, 4)));
    faellig = Date.now() + d;
    if (!sichtbar()) return; // weiter bei visibilitychange
    timer = setTimeout(fragen, d);
  }

  function fragen() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (zustand !== 'fragt' || laeuft) return;
    if (!erlaubt()) { stopp(); return; }
    if (!sichtbar()) return; // weiter bei visibilitychange
    laeuft = true;
    var gen = generation;
    var fertig = false;
    var abbruch = setTimeout(function () {
      ende('fehler', null);
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    }, ZEIT);
    function ende(art, d) {
      if (fertig) return;
      fertig = true;
      clearTimeout(abbruch);
      laeuft = false;
      ctrl = null;
      if (gen !== generation || zustand !== 'fragt') return; // inzwischen widerrufen oder beendet
      if (art === 'schluss') { zustand = 'ende'; return; }
      if (art === 'fehler') { fehler++; planen(); return; }
      fehler = 0;
      var a = pruefe(d);
      if (a && bekannt[a.code] === 1) { bestaetigen(a.code); planen(POLL); return; }
      if (a) { angebotDa(a, true); return; }
      planen(POLL);
    }
    var opt = { method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', body: JSON.stringify({ shop: location.hostname, c: nummer() }) };
    try { if (window.AbortController) { ctrl = new AbortController(); opt.signal = ctrl.signal; } } catch (e) { ctrl = null; }
    fetch(API, opt)
      .then(function (r) {
        var st = r.status;
        if (st === 204) return 'schluss';
        if (st === 429 || st >= 500) return 'fehler';
        if (st >= 400) return 'schluss'; // 400, 403, 413 …: diese Seite fragt nicht mehr
        if (st !== 200) return 'fehler';
        return r.json().then(function (d) { return d; }, function () { return 'fehler'; });
      })
      .then(function (d) {
        if (d === 'schluss' || d === 'fehler') { ende(d, null); return; }
        if (!d || typeof d !== 'object' || d.ok !== true) { ende('fehler', null); return; }
        ende('ok', d);
      })
      .catch(function () { ende('fehler', null); });
  }

  // Antwort prüfen: nur ein vollständiges, noch gültiges Angebot mit Serverzeit zählt. Alles andere = kein Angebot.
  function pruefe(d) {
    var a = d && d.angebot;
    if (!a || typeof a !== 'object') return null;
    var code = typeof a.code === 'string' ? a.code : '';
    if (!CODE_RE.test(code)) return null;
    if (!/^(100|[1-9][0-9]?)(\.[0-9])?$/.test(String(a.prozent))) return null;
    var p = Number(a.prozent);
    if (!(p >= 1 && p <= 100)) return null;
    var bis = typeof a.bis === 'string' ? Date.parse(a.bis) : NaN;
    var j = typeof d.jetzt === 'string' ? Date.parse(d.jetzt) : NaN;
    if (!(bis > 0) || !(j > 0)) return null; // ohne Serverzeit kein ehrlicher Countdown
    var x = { code: code, p: p, bis: bis, versatz: j - Date.now() };
    return rest(x) > 5000 ? x : null;
  }
  // Restzeit nach Serveruhr: Geräteuhr + Abstand zur Serveruhr beim Empfang
  function jetzt(a) { return Date.now() + (a ? a.versatz : 0); }
  function rest(a) { return a ? a.bis - jetzt(a) : 0; }

  // ── Wann das Fenster erscheinen darf ──
  function cookieOffen() {
    var b = document.getElementById('kxCookieBanner');
    var m = document.getElementById('kxCookieSettingsModal');
    if (b && b.getAttribute('data-open') === 'true') return true;
    if (m && m.getAttribute('data-open') === 'true') return true;
    return html.classList.contains('kx-cset-open');
  }
  var KLASSEN_HTML = ['klc-panel-open', 'klc-full-open', 'kx-wo-open'];
  var KLASSEN_BODY = ['kx-drawer-open', 'sa-modal-open', 'overflow-hidden-mobile', 'modal-open', 'kx-desc-sheet-open'];
  function andereOffen() {
    var i;
    for (i = 0; i < KLASSEN_HTML.length; i++) if (html.classList.contains(KLASSEN_HTML[i])) return true;
    var b = document.body;
    if (b) for (i = 0; i < KLASSEN_BODY.length; i++) if (b.classList.contains(KLASSEN_BODY[i])) return true;
    if (document.getElementById('kx-guard')) return true;
    if (document.querySelector('dialog[open]')) return true;
    var ei = document.getElementById('kxExitIntent');
    if (ei && !ei.hasAttribute('hidden')) return true;
    var ref = document.getElementById('kx-ref-overlay');
    if (ref && ref.style.display && ref.style.display !== 'none') return true;
    // Ebenen des Themes ohne <dialog> und ohne Klasse am body: Bild-Lightbox, „Alle Produkte“ von Zusammen kaufen,
    // Bewertungsfenster, Kopfleisten-Schublade. Das Fenster läge sonst unsichtbar dahinter und hielte Fokus und Escape fest.
    if (document.querySelector('#ProductLightbox[aria-hidden="false"], #kxBtModal.is-visible, #kxBtModal.is-open, #kxRevModal.is-open, details.menu-open')) return true;
    if (modalSichtbar()) return true;
    var f = document.activeElement;
    if (f && f !== document.body) {
      var t = (f.tagName || '').toLowerCase();
      if (t === 'input' || t === 'textarea' || t === 'select' || f.isContentEditable) return true;
    }
    return false;
  }

  // Allgemein: jedes sichtbare modale Fenster (role=dialog, aria-modal=true) außerhalb dieses Fensters zählt als offen.
  function modalSichtbar() {
    var l = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < l.length; i++) {
      var el = l[i];
      if (el.closest && el.closest('.kx-la, #kxCookieSettingsModal, #kxCookieBanner')) continue;
      if (el.hidden || el.getAttribute('aria-hidden') === 'true') continue;
      if (!el.getClientRects().length) continue;
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (cs && (cs.visibility === 'hidden' || cs.display === 'none' || Number(cs.opacity) === 0)) continue;
      return true;
    }
    return false;
  }

  // neu = gerade von der App gekommen (nicht aus dem Sitzungs-Merker): dann den Empfang bestätigen
  function angebotDa(a, neu) {
    if (timer) { clearTimeout(timer); timer = null; }
    zustand = 'wartet';
    angebot = a;
    bekannt[a.code] = 1;
    merken(a);
    if (neu) bestaetigen(a.code);
    versuchen();
  }

  // Empfang bestätigen: danach liefert die App diesen Code nicht mehr. Ohne Antwort-Auswertung; geht sie verloren, liefert die
  // App den Code bei der nächsten Abfrage noch einmal und diese Seite bestätigt erneut (siehe ende()).
  function bestaetigen(code) {
    var c = nummer();
    if (!c || !erlaubt()) return;
    try {
      fetch(API, { method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', keepalive: true, body: JSON.stringify({ shop: location.hostname, c: c, ok: code }) })
        .catch(function () {});
    } catch (e) {}
  }

  function spaeter(ms) {
    if (warteTimer) clearTimeout(warteTimer);
    warteTimer = setTimeout(versuchen, ms);
  }

  function versuchen() {
    warteTimer = null;
    if (zustand !== 'wartet') return;
    if (!erlaubt()) { stopp(); return; }
    if (rest(angebot) <= 5000) { vergessen(); angebot = null; zustand = 'fragt'; planen(POLL); return; }
    if (cookieOffen()) { warteteCookie = true; spaeter(WARTE); return; }
    if (warteteCookie) { warteteCookie = false; spaeter(NACH_COOKIE); return; }
    if (!sichtbar() || andereOffen()) { spaeter(WARTE); return; }
    var gen = generation;
    stilLaden(function (ok) {
      if (gen !== generation || zustand !== 'wartet') return;
      if (!ok) { spaeter(30000); return; } // ohne Stil kein Fenster; der Merker bleibt, die nächste Seite versucht es
      if (!sichtbar() || andereOffen() || cookieOffen()) { spaeter(WARTE); return; }
      oeffnen();
    });
  }

  var stilStand = 0; // 0 nicht geladen, 1 lädt, 2 bereit, 3 Fehler
  var stilWartet = [];
  function stilLaden(cb) {
    if (stilStand === 2) { cb(true); return; }
    if (stilStand === 3 || !CSS) { cb(false); return; }
    stilWartet.push(cb);
    if (stilStand === 1) return;
    stilStand = 1;
    var fertig = function (ok) {
      if (stilStand !== 1) return;
      stilStand = ok ? 2 : 3;
      var w = stilWartet;
      stilWartet = [];
      for (var i = 0; i < w.length; i++) w[i](ok);
    };
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = CSS;
    l.onload = function () { fertig(true); };
    l.onerror = function () { fertig(false); };
    setTimeout(function () { fertig(false); }, 10000);
    document.head.appendChild(l);
  }

  // ── Fenster ──
  function prozentText(p) {
    try { return new Intl.NumberFormat(LANG, { style: 'percent', maximumFractionDigits: 1 }).format(p / 100); } catch (e) { return p + ' %'; }
  }
  // Uhrzeit des Endes: der echte Zeitpunkt `bis` in der Zeitzone des Geräts (eine falsch gestellte Geräteuhr ändert ihn nicht).
  // „heute“ wird mit der Serverzeit verglichen.
  function bisText(el, a) {
    var d = new Date(a.bis);
    var h = new Date(jetzt(a));
    var loc = LANG === 'en' ? 'en-GB' : LANG;
    var t;
    var tag;
    try {
      t = new Intl.DateTimeFormat(loc, { hour: '2-digit', minute: '2-digit', hour12: false }).format(d);
      tag = new Intl.DateTimeFormat(loc, { day: '2-digit', month: '2-digit' }).format(d);
    } catch (e) {
      t = zwei(d.getHours()) + ':' + zwei(d.getMinutes());
      tag = zwei(d.getDate()) + '.' + zwei(d.getMonth() + 1) + '.';
    }
    var heute = d.getFullYear() === h.getFullYear() && d.getMonth() === h.getMonth() && d.getDate() === h.getDate();
    var vorlage = (heute ? el.getAttribute('data-heute') : el.getAttribute('data-tag')) || '{t}';
    el.textContent = vorlage.replace('{d}', tag).replace('{t}', t);
  }
  function restText(ms) {
    var s = Math.ceil(ms / 1000);
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var x = s % 60;
    return (h ? h + ':' + zwei(m) : String(m)) + ':' + zwei(x);
  }
  var uhr = null;
  var restZeile = null;
  function restAufbauen(el) {
    var teile = (el.getAttribute('data-tpl') || '{r}').split('{r}');
    var trenner = document.createElement('span');
    trenner.className = 'kx-la__dot';
    trenner.setAttribute('aria-hidden', 'true');
    trenner.textContent = '·';
    el.appendChild(trenner);
    if (teile[0]) el.appendChild(document.createTextNode(teile[0]));
    uhr = document.createElement('strong');
    uhr.className = 'kx-la__uhr';
    uhr.setAttribute('role', 'timer');
    el.appendChild(uhr);
    if (teile[1]) el.appendChild(document.createTextNode(teile[1]));
    restZeile = el;
  }

  function q(sel) { return root ? root.querySelector(sel) : null; }

  function oeffnen() {
    var a = angebot;
    var frag = tpl.content.cloneNode(true);
    root = frag.querySelector('.kx-la');
    if (!root) { zustand = 'ende'; return; }
    panel = root.querySelector('.kx-la__panel');
    var pt = prozentText(a.p);
    var el = q('[data-kx-la-pct]');
    if (el) el.textContent = pt;
    el = q('#kxLaText');
    if (el) el.textContent = (el.getAttribute('data-tpl') || '').replace('{p}', pt);
    el = q('[data-kx-la-code]');
    if (el) el.textContent = a.code;
    el = q('[data-kx-la-bis]');
    if (el) bisText(el, a);
    uhr = null;
    restZeile = null;
    el = q('[data-kx-la-rest]');
    if (el) restAufbauen(el);
    document.body.appendChild(frag);

    root.addEventListener('click', klick);
    vorherFokus = document.activeElement;
    zustand = 'offen';
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    html.classList.add('kx-la-open');
    document.addEventListener('keydown', taste, true);
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    tick();
  }

  function tick() {
    if (tickTimer) { clearTimeout(tickTimer); tickTimer = null; }
    if (zustand !== 'offen') return;
    var ms = rest(angebot);
    if (ms <= 0) { zu(true); return; } // abgelaufen: der Code gilt nicht mehr
    if (restZeile && uhr) {
      if (ms < 864e5) { uhr.textContent = restText(ms); restZeile.hidden = false; }
      else restZeile.hidden = true;
    }
    tickTimer = setTimeout(tick, (ms % 1000) || 1000);
  }

  // Schließen: Merker weg, Fenster weg. weiter = danach wieder im Takt fragen (die Inhaberin kann später noch einen schicken).
  function zu(weiter) {
    if (zustand !== 'offen') return;
    zustand = weiter ? 'fragt' : 'aus';
    angebot = null;
    vergessen();
    if (tickTimer) { clearTimeout(tickTimer); tickTimer = null; }
    document.removeEventListener('keydown', taste, true);
    html.classList.remove('kx-la-open');
    var r = root;
    root = null;
    r.classList.remove('is-open');
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { r.hidden = true; if (r.parentNode) r.parentNode.removeChild(r); }, still ? 0 : 320);
    if (vorherFokus && vorherFokus.focus && vorherFokus !== document.body && document.contains(vorherFokus)) {
      try { vorherFokus.focus({ preventScroll: true }); } catch (e) {}
    }
    if (weiter) { fehler = 0; planen(POLL); }
  }

  function fokussierbar() {
    var l = panel.querySelectorAll('button:not([disabled]), a[href]');
    var out = [];
    for (var i = 0; i < l.length; i++) if (l[i].offsetWidth || l[i].offsetHeight) out.push(l[i]);
    return out;
  }
  function taste(e) {
    if (zustand !== 'offen') return;
    var k = e.key || e.keyCode;
    if (k === 'Escape' || k === 'Esc' || k === 27) { e.preventDefault(); e.stopPropagation(); zu(true); return; }
    if (k === 'Tab' || k === 9) {
      var f = fokussierbar();
      if (!f.length) { e.preventDefault(); panel.focus(); return; }
      var erstes = f[0];
      var letztes = f[f.length - 1];
      var akt = document.activeElement;
      if (!panel.contains(akt)) { e.preventDefault(); erstes.focus(); }
      else if (e.shiftKey && (akt === erstes || akt === panel)) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && akt === letztes) { e.preventDefault(); erstes.focus(); }
    }
  }

  function klick(e) {
    var t = e.target;
    var r = root;
    while (t && t !== r) {
      if (t.hasAttribute) {
        if (t.hasAttribute('data-kx-la-zu')) { e.preventDefault(); zu(true); return; }
        if (t.hasAttribute('data-kx-la-kopie')) { e.preventDefault(); kopieren(t); return; }
        if (t.hasAttribute('data-kx-la-einloesen')) { e.preventDefault(); einloesen(); return; }
      }
      t = t.parentNode;
    }
  }

  function kopieren(btn) {
    var code = angebot ? angebot.code : '';
    if (!code) return;
    var txt = btn.querySelector('[data-kx-la-kopie-txt]') || btn;
    var live = q('[data-kx-la-live]');
    var fertig = function () {
      // Kopiert = der Code kann an der Kasse eingelöst werden. Der Merker fällt weg, damit das Fenster nach einem Seitenwechsel
      // nicht mit einem womöglich schon eingelösten Code wiederkommt (hier bleibt es offen, bis der Besucher es schließt).
      vergessen();
      txt.textContent = btn.getAttribute('data-done') || '';
      btn.classList.add('is-done');
      if (live) live.textContent = btn.getAttribute('data-done') || '';
      setTimeout(function () {
        txt.textContent = btn.getAttribute('data-label') || '';
        btn.classList.remove('is-done');
        if (live) live.textContent = '';
      }, 2000);
    };
    var alt = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;';
      panel.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      panel.removeChild(ta);
      try { btn.focus({ preventScroll: true }); } catch (e) {}
      if (ok) fertig();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fertig, alt);
    else alt();
  }

  function einloesen() {
    if (!angebot) return;
    var code = angebot.code;
    var ziel = (location.pathname || '/') + (location.search || '');
    vergessen(); // nach dem Einlösen soll das Fenster auf der nächsten Seite nicht wieder aufspringen
    window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ziel);
  }

  // ── Start, Widerruf, Sichtbarkeit ──
  function start() {
    if (!erlaubt()) { vergessen(); return; }
    if (zustand !== 'aus') return;
    fehler = 0;
    var a = gemerkt();
    if (a) { zustand = 'fragt'; angebotDa(a); return; }
    zustand = 'fragt';
    planen(START);
  }

  function stopp() {
    generation++;
    if (timer) { clearTimeout(timer); timer = null; }
    if (warteTimer) { clearTimeout(warteTimer); warteTimer = null; }
    if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
    laeuft = false;
    if (zustand === 'offen') zu(false);
    if (zustand !== 'ende') zustand = 'aus';
    angebot = null;
    vergessen();
  }

  // Einwilligung neu bewerten: erlaubt = (wieder) fragen; sonst sofort aufhören
  function neu() {
    if (erlaubt()) start();
    else stopp();
  }

  try {
    window.addEventListener('kx:consent', function () { setTimeout(neu, 0); });
    window.addEventListener('storage', function (e) {
      if (!e || e.key === null || e.key === 'karinex_cookie_settings' || e.key === 'karinex_cookie_consent') neu();
    });
    document.addEventListener('visibilitychange', function () {
      if (!sichtbar()) {
        // im Hintergrund nie fragen: geplante Frage anhalten (eine laufende darf zu Ende gehen)
        if (timer) { clearTimeout(timer); timer = null; }
        return;
      }
      if (zustand === 'fragt' && !laeuft) {
        // Zurück im Tab: sofort fragen, in einer Fehlerpause erst nach deren Ende
        var w = fehler ? faellig - Date.now() : 0;
        if (w <= 0) fragen();
        else planen(w);
      } else if (zustand === 'offen') tick();
    });
    window.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) return;
      neu();
      if (zustand === 'offen') tick();
    });
  } catch (e) {}

  start();
})();
